<template>
 <div class="text-block block-card card-border pt-5">
    <div class="primary escalate-agent-mark"></div>
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <v-icon class="white--text">speaker_notes_off</v-icon>
            </div>

            <h4>
              End Conversation
            </h4>
          </div>
        </template>
        <div class="mb-2"/>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
export default {

  name: 'card-end-conversation',

  data () {
    return {
      panel: 1,
      lazyRendering: true
    }
  },
  mounted() {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
  },
}
</script>

<style lang="css" scoped>
.escalate-agent-mark {
    height: 25px;
    border-radius: 8px 8px 0 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>